import React from 'react';
import classNames from 'classnames'

export const Modal = ({ icon, headline, content, children, acceptAction, acceptText, abortAction, abortText, isOpen }) => {
  
  const modalClasses = classNames('bg-black/30 py-30px overflow-auto fixed top-[64px] left-0 bottom-[90px] right-0 z-50 transition-all lg:top-0 lg:bottom-0 lg:left-[300px]',
    {
      'opacity-0 invisible': !isOpen,
      'opacity-100 visible' : isOpen
    }
  )

  return (

    <div className={modalClasses}>

      <div className={classNames('bg-white max-w-[400px] p-6 mx-auto mt-[15%] rounded-xl shadow-2xl overflow-hidden transition-all',
        {
          'translate-y-0': isOpen,
          'translate-y-20': !isOpen
        }
      )}>

        <div className="pt-6 pb-3">

          <div className="mb-4 text-brand-1 text-center text-6xl">
            <span className={`icon ${icon}`}></span>
          </div>
          
          <div className="mb-3 font-semibold text-center text-xl">{headline}</div>

          {content && (
            <p className="mb-3 text-center">{content}</p>
          )}
          
          {children}

        </div>

        <div className="flex">
          { abortAction && (
            <button onClick={abortAction} className={classNames('bg-gray-300 py-3 px-4 flex justify-center border-0 text-md rounded-md font-semibold transition-all hover:bg-gray-400',
              {
                'basis-full mr-0': !acceptAction,
                'basis-1/2 mr-6': acceptAction
              }
            )}>
              {abortText}
            </button>
          )}
          { acceptAction && (
            <button onClick={acceptAction} className={classNames('bg-brand-1 py-3 px-4 flex justify-center border-0 text-md text-white rounded-md font-semibold transition-all hover:bg-brand-1/80',
              {
                'basis-full': !abortAction,
                'basis-1/2': abortAction
              }
            )}>
              {acceptText}
            </button>
          )}
        </div>

      </div>

    </div>
    
  );
  
};
